import {
  defaultMenuType,
  subHiddenBreakpoint,
  menuHiddenBreakpoint,
} from 'constants/defaultValues';
import {
  MENU_SET_CLASSNAMES,
  MENU_CONTAINER_ADD_CLASSNAME,
  MENU_CLICK_MOBILE_MENU,
  MENU_SELECTED_VALUE,
  LOGOUT_USER,
  MENU_CHANGE_DEFAULT_CLASSES,
  MENU_CHANGE_HAS_SUB_ITEM_STATUS,
  MENU_CHANGE_HAS_TOP_NAV_ITEM_STATUS,
  ACTIVE_MENU_TREE
} from '../constants';

const INIT_STATE = {
  containerClassnames: defaultMenuType,
  subHiddenBreakpoint,
  menuHiddenBreakpoint,
  activeMenuTree:{},
  selectedMenuItem:0,
  selectedMenuObject:{menuId:0},
  menuClickCount: 2,
  selectedMenuHasTopNavItems: false,
  selectedMenuHasSubItems: defaultMenuType === 'menu-default', // if you use menu-sub-hidden as default menu type, set value of this variable to false
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case MENU_CHANGE_HAS_SUB_ITEM_STATUS:
      return { ...state, selectedMenuHasSubItems: action.payload };

    case MENU_CHANGE_HAS_TOP_NAV_ITEM_STATUS:
      return { ...state, selectedMenuHasTopNavItems: action.payload };
      
    case MENU_SELECTED_VALUE:
      return { ...state, selectedMenuItem: action.payload.hasId,  selectedMenuObject:action.payload.mi }

    case LOGOUT_USER:
      return INIT_STATE;
      break;
    case ACTIVE_MENU_TREE:
       return {
        ...state,
        activeMenuTree: action.payload
      };
    case MENU_SET_CLASSNAMES:
      return {
        ...state,
        containerClassnames: action.payload.containerClassnames,
        menuClickCount: action.payload.menuClickCount,
      };

    case MENU_CLICK_MOBILE_MENU:
      return {
        ...state,
        containerClassnames: action.payload.containerClassnames,
        menuClickCount: action.payload.menuClickCount,
      };

    case MENU_CONTAINER_ADD_CLASSNAME:
      return { ...state, containerClassnames: action.payload };

    case MENU_CHANGE_DEFAULT_CLASSES:
      return { ...state, containerClassnames: action.payload };

    default:
      return { ...state };
  }
};
